module.exports = __webpack_public_path__ + "static/media/process_2.966c4f47.png";